module.exports = __webpack_public_path__ + "static/media/Anticipation_1.4fb5896d.jpg";